import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { SeriesType, ValueAxisLabels } from '@progress/kendo-angular-charts';
import 'hammerjs';
import { ThemeManagerService } from '~/services/theme-manager';

@Component({
    selector: 'kendochart-form',
    templateUrl: './kendochart-form.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KendoChartFormComponent implements OnInit {
  public listChartData: Array<any>;
  public listChartDataName: string;
  public topNlistChartData: any = 5;
  public categories: string[];
  public seriesData1: any[];
  public seriesData2: any[];
  public seriesData3: any[];
  public seriesData4: any[];
  public seriesData5: any[];
  public seriesData1Visible = true;
  public seriesData2Visible = true;
  public seriesData3Visible = true;
  public seriesData4Visible = true;
  public seriesData5Visible = true;
  public seriesData1Name: string;
  public seriesData2Name: string;
  public seriesData3Name: string;
  public seriesData4Name: string;
  public seriesData5Name: string;
  public chartHeight: number = 5 * 70;
  public accounts: string[];
  public stacked = false;
  public backgroundTheme = "white";
  public textColorTheme = "#000000";
  public labelColor = { color: '#000000' };
  public labelColorInactive = { color: '#787878' };
  public majorGridLines = { color: 'lightgray', visible: true, width: 1 };
  public valueAxisLabels: ValueAxisLabels = {
    font: 'normal 12px Arial, sans-serif'
  };
  public seriesType: SeriesType;

  constructor(
    private _themeManager: ThemeManagerService,
  ) {
    this._themeManager.themeChange.subscribe(x => {
      if (x == 'enterprise') {
        this.backgroundTheme = "#FFFFFF";
        this.textColorTheme = "#000000";
        this.labelColor = { color: '#000000' };
        this.labelColorInactive = { color: '#e4e7eb' };
        this.majorGridLines = { color: 'lightgray', visible: true, width: 1 };
      } else {
        this.backgroundTheme = "#000000";
        this.textColorTheme = "#FFFFFF";
        this.labelColor = { color: '#FFFFFF' };
        this.labelColorInactive = { color: '#787878' };
        this.majorGridLines = { color: 'white', visible: true, width: .2 };
      }
    });
  }
  ngOnInit(): void {

  }

  @Input() public set isStacked(_isStacked: any) {
    if (_isStacked != undefined && _isStacked.length != 0) {
      this.stacked = _isStacked;
    }
  }

  @Input() public set userAccounts(_userAccounts: any) {
    if (_userAccounts != undefined && _userAccounts.length != 0) {
      this.accounts = _userAccounts.map((a: any) => a.AccountName);
    }
  }

  @Input() public set chartName(_chartName: any) {
    if (_chartName != undefined && _chartName.length != 0) {
      this.listChartDataName = _chartName;
    }
  }
  @Input() public set chartType(_chartType: any) {
    if (_chartType != undefined && _chartType.length != 0) {
      this.seriesType = _chartType;
    }
  }
  @Input() public set topN(top: any) {
    if (top != undefined && top.length != 0) {
      this.topNlistChartData = top;
    }
  }

  @Input() public set model(ChartData: any) {
    if (ChartData != undefined && ChartData.length != 0) {
      if (this.topNlistChartData != 'all') {
        this.listChartData = ChartData.slice(0, this.topNlistChartData);
      } else {
        this.listChartData = ChartData;
      }
      if (this.topNlistChartData != 5) {
        this.chartHeight = this.listChartData.length * 70;
      }
      switch (this.listChartDataName) {
        case 'BurnRate':
          this.categories = this.listChartData.map((a) => a.PPEItem || a.ppeItem || a.Category || a.category || 'Uncategorized');
          this.seriesData1 = this.listChartData.map((a) => a.SumOfDistribution ?? a.sumOfDistribution ?? 0);
          this.seriesData2 = this.listChartData.map((a) => a.AvgDailyBurnRate ?? a.avgDailyBurnRate ?? 0);
          this.seriesData3 = this.listChartData.map((a) => a._72HourBurnRate ?? a._72hourBurnRate ?? 0);
          this.seriesData4 = this.listChartData.map((a) => a._10DayBurnRate ?? a._10dayBurnRate ?? 0);
          this.seriesData5Visible = false;
          this.seriesData1Name = 'Sum of Distribution';
          this.seriesData2Name = 'Avg Daily / Burn Rate';
          this.seriesData3Name = '72 Hours / Burn Rate';
          this.seriesData4Name = '10 Days / Burn Rate';
          break;
        case 'IssuancePerItem':
          this.categories = this.listChartData.map((a) => a.Item);
          this.seriesData1 = this.listChartData.map((a) => a.QuantityIssued);
          this.seriesData2 = this.listChartData.map((a) => a.DailyIssuanceRate);
          this.seriesData3 = this.listChartData.map(
            (a) => a.MonthlyIssuanceRate
          );
          this.seriesData4 = this.listChartData.map((a) => a.OnHand);
          this.seriesData5 = this.listChartData.map(
            (a) => a.RemainingDaysOnHand
          );
          this.seriesData1Name = 'Quantity Issued';
          this.seriesData2Name = 'Daily Issuance Rate';
          this.seriesData3Name = 'Monthly Issuance Rate';
          this.seriesData4Name = 'On Hand';
          this.seriesData5Name = 'Remaining Days on Hand';
          break;
        case 'InventorySummary':
          this.categories = this.listChartData.map((a) => a.category);
          this.seriesData1 = this.listChartData.map((a) => a.itemsquantity);
          this.seriesData2Visible = false;
          this.seriesData3Visible = false;
          this.seriesData4Visible = false;
          this.seriesData5Visible = false;
          this.seriesData1Name = 'Items Quantity';
          break;
        case 'GetOnHandByCategory':
          this.categories = this.listChartData.map(
            (a) => a.Category || a.category || a.categoriesCategoryCode || a.StockDescription || 'Uncategorized'
          );
          if (!this.accounts || this.accounts.length === 0) {
            if (this.listChartData && this.listChartData.length > 0) {
              const keys = Object.keys(this.listChartData[0]);
              const exclude = ['Category', 'categoriesCategoryCode', 'category', 'itemsquantity', 'itemsQuantity', 'StockDescription'];
              this.accounts = keys.filter(k => !exclude.includes(k));
            }
          }
          if (this.accounts && this.accounts.length > 0) {
            var accountsLength = this.accounts.length;
            if (accountsLength > 0) {
              var seriesData1Arr = [];
              for (var i = 0; i < this.listChartData.length; i++) {
                var val1 = this.listChartData[i][this.accounts[0]];
                if (val1 === undefined || val1 === null) {
                  val1 = this.listChartData[i]['itemsquantity'] ?? this.listChartData[i]['itemsQuantity'] ?? 0;
                }
                seriesData1Arr.push(val1);
              }
              this.seriesData1 = seriesData1Arr;
              this.seriesData1Name = this.accounts[0];

              if (accountsLength > 1) {
                var seriesData2Arr = [];
                for (var i = 0; i < this.listChartData.length; i++) {
                seriesData2Arr.push(this.listChartData[i][this.accounts[1]]);
                }
                this.seriesData2 = seriesData2Arr;
                this.seriesData2Name = this.accounts[1];

                if (accountsLength > 2) {
                  var seriesData3Arr = [];
                  for (var i = 0; i < this.listChartData.length; i++) {
                  seriesData3Arr.push(this.listChartData[i][this.accounts[2]]);
                  }
                  this.seriesData3 = seriesData3Arr;
                  this.seriesData3Name = this.accounts[2];

                  if (accountsLength > 3) {
                    var seriesData4Arr = [];
                    for (var i = 0; i < this.listChartData.length; i++) {
                      var val4 = this.listChartData[i][this.accounts[3]];
                      if (val4 === undefined || val4 === null) {
                        val4 = 0;
                      }
                      seriesData4Arr.push(val4);
                    }
                    this.seriesData4 = seriesData4Arr;
                    this.seriesData4Name = this.accounts[3];

                    if (accountsLength > 4) {
                      var seriesData5Arr = [];
                      for (var i = 0; i < this.listChartData.length; i++) {
                        var val5 = this.listChartData[i][this.accounts[4]];
                        if (val5 === undefined || val5 === null) {
                          val5 = 0;
                        }
                        seriesData5Arr.push(val5);
                      }
                      this.seriesData5 = seriesData5Arr;
                      this.seriesData5Name = this.accounts[4];
                    }
                  }
                }
              }
            }
            if (accountsLength < 5) {
              this.seriesData5Visible = false;
              if (accountsLength < 4) {
                this.seriesData4Visible = false;
                if (accountsLength < 3) {
                  this.seriesData3Visible = false;
                  if (accountsLength < 2) {
                    this.seriesData2Visible = false;
                    if (accountsLength < 1) {
                      this.seriesData1Visible = false;
                    }
                  }
                }
              }
            }
          } else {
            this.seriesData1 = this.listChartData.map((a) => a.itemsquantity ?? a.itemsQuantity ?? 0);
            this.seriesData1Name = 'Items Quantity';
            this.seriesData2Visible = false;
            this.seriesData3Visible = false;
            this.seriesData4Visible = false;
            this.seriesData5Visible = false;
          }
          break;
      }
    }
  }
}
